import { skipToken, useQuery } from '@tanstack/react-query'
import ProcessesApi from '@/infrastructure/api/processes'

export const processDetailsKey = (processId?: string) =>
  ['processDetails', processId] as const

export function useProcessDetails(processId?: string) {
  const processDetailsQuery = useQuery({
    queryKey: processDetailsKey(processId),
    queryFn:
      processId !== undefined
        ? () => ProcessesApi.getProcess({ processId })
        : skipToken
  })

  return {
    processDetails: processDetailsQuery.data,
    loadingProcess: processDetailsQuery.isLoading
  }
}
